"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var R = require("ramda");
var React = require("react");
var AbstractImage = require("../model/index");
function createReactSvg(image, callbacks) {
    var cb = callbacks || {};
    var id = "ai_root";
    return (React.createElement("svg", { id: id, width: image.size.width + "px", height: image.size.height + "px", viewBox: [0, 0, image.size.width, image.size.height].join(" "), onClick: _callback(cb.onClick, id), onDoubleClick: _callback(cb.onDoubleClick, id), onMouseMove: _callback(cb.onMouseMove, id), onContextMenu: _callback(cb.onContextMenu, id) }, R.unnest(R.addIndex(R.map)(
    // tslint:disable-next-line:no-any
    function (c, i) { return _visit(i.toString(), c); }, image.components))));
}
exports.createReactSvg = createReactSvg;
function _callback(callback, rootId) {
    if (!callback) {
        return undefined;
    }
    return function (e) {
        var rect = e.currentTarget.getBoundingClientRect();
        var offsetX = e.clientX - rect.left;
        var offsetY = e.clientY - rect.top;
        var mousePoint = AbstractImage.createPoint(offsetX, offsetY);
        var id = getIdAttr(e.target, rootId);
        callback(id && id !== "" ? id : undefined, mousePoint);
    };
}
function makeIdAttr(id) {
    if (!id) {
        return undefined;
    }
    return "ai%" + id;
}
function getIdAttr(target, rootId) {
    if (!target || target.id === rootId) {
        return undefined;
    }
    var id = target.id;
    var parts = id.split("%");
    if (parts.length !== 2 || parts[0] !== "ai") {
        return getIdAttr(target.parentNode || undefined, rootId);
    }
    return parts[1];
}
function _visit(key, component) {
    switch (component.type) {
        case "group":
            return [
                React.createElement("g", { key: key, name: component.name }, R.unnest(R.addIndex(R.map)(
                // tslint:disable-next-line:no-any
                function (c, i) { return _visit(i.toString(), c); }, component.children)))
            ];
        case "binaryimage":
            switch (component.format) {
                case "svg":
                    return [
                        React.createElement("g", { key: key, id: makeIdAttr(component.id), dangerouslySetInnerHTML: {
                                __html: component.data.reduce(function (a, b) { return a + String.fromCharCode(b); }, "")
                            } })
                    ];
                default:
                    return [];
            }
        case "line":
            return [
                React.createElement("line", { id: makeIdAttr(component.id), key: key, x1: component.start.x, y1: component.start.y, x2: component.end.x, y2: component.end.y, stroke: colorToRgb(component.strokeColor), strokeWidth: component.strokeThickness, strokeOpacity: colorToOpacity(component.strokeColor) })
            ];
        case "text":
            if (!component.text) {
                return [];
            }
            var lineHeight_1 = component.fontSize;
            var shadowStyle = {
                textAnchor: getTextAnchor(component.horizontalGrowthDirection),
                fontSize: component.fontSize.toString() + "px",
                fontWeight: component.fontWeight,
                fontFamily: component.fontFamily,
                stroke: colorToRgb(component.strokeColor),
                strokeWidth: component.strokeThickness
            };
            var style = {
                textAnchor: getTextAnchor(component.horizontalGrowthDirection),
                fontSize: component.fontSize.toString() + "px",
                fontWeight: component.fontWeight,
                fontFamily: component.fontFamily,
                fill: colorToRgb(component.textColor)
            };
            var dy_1 = getBaselineAdjustment(component.verticalGrowthDirection);
            var transform = "rotate(" +
                component.clockwiseRotationDegrees.toString() +
                " " +
                component.position.x.toString() +
                " " +
                component.position.y.toString() +
                ")";
            var lines_1 = component.text !== null ? component.text.split("\n") : [];
            var tSpans = lines_1.map(function (t) {
                return renderLine(t, component.position.x, component.position.y + (lines_1.indexOf(t) + dy_1) * lineHeight_1, component.fontSize, lineHeight_1);
            });
            var cs = [];
            if (component.strokeThickness > 0 && component.strokeColor) {
                cs.push(React.createElement("text", { key: key + "shadow", style: shadowStyle, transform: transform }, tSpans));
            }
            cs.push(React.createElement("text", { key: key, style: style, transform: transform }, tSpans));
            return cs;
        case "ellipse":
            var rx = Math.abs(component.bottomRight.x - component.topLeft.x) * 0.5;
            var ry = Math.abs(component.bottomRight.y - component.topLeft.y) * 0.5;
            var cx = (component.bottomRight.x + component.topLeft.x) * 0.5;
            var cy = (component.bottomRight.y + component.topLeft.y) * 0.5;
            return [
                React.createElement("ellipse", { id: makeIdAttr(component.id), key: key, cx: cx, cy: cy, rx: rx, ry: ry, stroke: colorToRgb(component.strokeColor), strokeWidth: component.strokeThickness, strokeOpacity: colorToOpacity(component.strokeColor), fillOpacity: colorToOpacity(component.fillColor), fill: colorToRgb(component.fillColor) })
            ];
        case "polyline":
            var linePoints = component.points
                .map(function (p) { return p.x.toString() + "," + p.y.toString(); })
                .join(" ");
            return [
                React.createElement("polyline", { id: makeIdAttr(component.id), key: key, points: linePoints, stroke: colorToRgb(component.strokeColor), strokeWidth: component.strokeThickness, strokeOpacity: colorToOpacity(component.strokeColor), fill: "none" })
            ];
        case "polygon":
            var points = component.points
                .map(function (p) { return p.x.toString() + "," + p.y.toString(); })
                .join(" ");
            return [
                React.createElement("polygon", { id: makeIdAttr(component.id), key: key, points: points, stroke: colorToRgb(component.strokeColor), strokeWidth: component.strokeThickness, strokeOpacity: colorToOpacity(component.strokeColor), fillOpacity: colorToOpacity(component.fillColor), fill: colorToRgb(component.fillColor) })
            ];
        case "rectangle":
            return [
                React.createElement("rect", { id: makeIdAttr(component.id), key: key, x: component.topLeft.x, y: component.topLeft.y, width: Math.abs(component.bottomRight.x - component.topLeft.x), height: Math.abs(component.bottomRight.y - component.topLeft.y), stroke: colorToRgb(component.strokeColor), strokeWidth: component.strokeThickness, strokeOpacity: colorToOpacity(component.strokeColor), fillOpacity: colorToOpacity(component.fillColor), fill: colorToRgb(component.fillColor) })
            ];
        default:
            return [];
    }
}
function renderLine(text, x, y, fontSize, lineHeight) {
    var split = R.unnest(text.split("<sub>").map(function (t) { return t.split("</sub>"); }));
    var inside = false;
    var tags = [];
    for (var _i = 0, split_1 = split; _i < split_1.length; _i++) {
        var text_1 = split_1[_i];
        if (inside) {
            tags.push(React.createElement("tspan", { baselineShift: "sub", style: { fontSize: (fontSize * 0.8).toString() + "px" } }, text_1));
        }
        else {
            tags.push(React.createElement("tspan", null, text_1));
        }
        inside = !inside;
    }
    return (React.createElement("tspan", { key: text, x: x, y: y, height: lineHeight.toString() + "px" }, tags));
}
function getBaselineAdjustment(d) {
    if (d === "up") {
        return 0.0;
    }
    if (d === "uniform") {
        return 0.5;
    }
    if (d === "down") {
        return 1.0;
    }
    throw "Unknown text alignment " + d;
}
function getTextAnchor(d) {
    if (d === "left") {
        return "end";
    }
    if (d === "uniform") {
        return "middle";
    }
    if (d === "right") {
        return "start";
    }
    throw "Unknown text alignment " + d;
}
function colorToRgb(color) {
    return ("rgb(" +
        color.r.toString() +
        "," +
        color.g.toString() +
        "," +
        color.b.toString() +
        ")");
}
function colorToOpacity(color) {
    return (color.a / 255).toString();
}
//# sourceMappingURL=react-svg-export-image.js.map